module.exports = __webpack_public_path__ + "static/media/p-bg.8786a394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-bg.svg
// module id = 458
// module chunks = 0